import { categories } from '@/mocks/categories';

export default function CategoryCards() {
  return (
    <section id="categories" className="w-full px-4 md:px-10 py-16 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            Explore Product Categories
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            Browse through our organized product categories. Each category links directly to curated spreadsheet resources on our main website.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer transition-all duration-300 hover:border-primary-300/50 hover:shadow-md"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} products category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-300"></div>
              </div>
              <div className="flex items-center gap-2 px-3 py-3">
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100/70 text-primary-600 flex-shrink-0">
                  <i className={`${cat.icon} text-xs`}></i>
                </div>
                <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap overflow-hidden text-ellipsis">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}